<template>
  <div>
    <v-card>
      <v-card-title class="pa-0">
        <base-table-header
          @search="onSearch"
          :btnFilter="true"
          :btnAdd="$allow('psp-pip-profil.create')"
          :btnDownload="false"
          @add="onAddAkun"
          @reload="onReload"
          @filter="onFilter"
          @download="onDownload"
        >
          <template v-slot:subtitle>
            <div class="subtitle-1 black--text"> {{ total }} Pendamping Implementasi Pembelajaran</div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text>
        <div>
          <base-list-table
            :hideHeader="true"
            :loading="loading"
            :item="data"
            :total="total"
            :usePaging="false"
            @fetch="fetchData"
          >
            <template slot-scope="{ item }">
              <td>
                <v-list two-line>
                  <v-list-item dense class="px-0">
                    <v-list-item-content>
                      <v-row>
                        <v-col class="py-0" cols="12" md="4">
                          <v-list-item class="px-0">
                            <v-list-item-avatar color="secondary">
                              <v-icon dark>mdi-account</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <div class="body-2 mb-0 grey--text">Nama Lengkap</div>
                              <div class="subtitle-1 black--text font-weight-medium mb-0">{{ item.nama || '-' }}</div>
                              <div class="subtitle-2 black--text">
                                SIMPKB ID:
                                <span class="font-weight-regular">
                                  {{ $getDeepObj(item, 'psp_profil.data.ptk_id') || '-' }}
                                </span>
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col class="py-0" cols="12" md="3">
                          <v-list-item class="px-0">
                            <v-list-item-content v-if="!isDirjenVokasi">
                              <div class="body-2 mb-0 grey--text">Nomor ID</div>
                              <div class="subtitle-2 black--text">
                                SIMPKB:
                                <span class="font-weight-regular">
                                  {{ $getDeepObj(item, 'psp_profil.data.ptk_id') || '-' }}
                                </span>
                              </div>
                            </v-list-item-content>
                            <v-list-item-content v-else>
                              <div class="body-2 mb-0 grey--text">Naungan Balai</div>
                              <div class="subtitle-1 black--text mb-0">
                                {{ $getDeepObj(item, 'instansi_p4tk.data.nama') || '-' }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col class="py-0" cols="12" md="3">
                          <v-list-item-content>
                            <div class="body-2 mb-0 grey--text">Kontak</div>
                            <div class="subtitle-2 black--text">
                              No HP: <span class="font-weight-regular">{{ item.no_wa || item.no_hp }}</span>
                            </div>
                            <div class="subtitle-2 black--text">
                              Email:
                              <span class="font-weight-regular">
                                {{
                                  +$getDeepObj(item, 'psp_profil.data.ptk.data.k_sumber') === 1
                                    ? $getDeepObj(item, 'psp_profil.data.ptk.data.alt_email') || '-'
                                    : item.email || '-'
                                }}
                              </span>
                            </div>
                          </v-list-item-content>
                        </v-col>
                        <v-col class="py-0" cols="12" md="2">
                          <v-list-item class="px-0">
                            <v-list-item-content>
                              <div class="body-2 mb-0 grey--text">Status</div>
                              <div>
                                <v-chip dark :color="statusPeserta(item) && statusPeserta(item)['color']">
                                  {{ statusPeserta(item) && statusPeserta(item)['label'] }}
                                </v-chip>
                              </div>
                              <div class="py-2 error--text caption">
                                {{ $getDeepObj(item, 'psp_profil.data.alasan_diskualifikasi') }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action-text>
                      <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                    </v-list-item-action-text>
                  </v-list-item>
                </v-list>
              </td>
            </template>
          </base-list-table>
        </div>
        <v-card-actions>
          <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <base-modal-full
      ref="modal"
      mode="form"
      general-error
      :auto-close="!formulir.is_edit"
      :use-save="formulir.is_edit"
      :title="formulir.title"
      @close="onCloseModal"
      @save="onSave"
    >
      <component
        :is="formulir.component"
        ref="formulir"
        :masters="masters"
        :initValue="formulir.init"
        :id="formulir['id']"
        :detail="formulir['detail']"
      />
    </base-modal-full>
  </div>
</template>
<script>
import FormulirAkun from './Formulir';
import FormStatus from './FormStatus.vue';
import DetailAkun from './Detail';
import list from '@mixins/list';
import actions from './actions';
import { mapActions, mapState } from 'vuex';

export default {
  components: { FormulirAkun, FormStatus, DetailAkun },
  mixins: [list],
  data() {
    return {
      actions: actions,
      formulir: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),
    ...mapState('preferensi', {
      instansi: (state) => state.data?.instansi ?? {},
      configInstansi: (state) => state.data?.config ?? {},
    }),

    isDirjenVokasi() {
      return this.instansi.instansi_id === 800007;
    },

    filtersMaster() {
      return {
        is_peserta: this.mStatusPeserta,
        gelombang: this.mGelombang,
      };
    },

    mStatusPeserta() {
      return {
        1: 'Peserta Diklat',
      };
    },

    mGelombang() {
      let temp = {};
      const gelombang = this.$getDeepObj(this.configInstansi, 'pip.gelombang') || 1;

      for (let i = 1; i <= Number(gelombang); i++) {
        this.$set(temp, i, `Angkatan ${i}`);
      }

      return temp;
    },

    formFilter() {
      let temp = [
        {
          label: 'Pilih Status Peserta Diklat',
          default: true,
          type: 'select',
          model: 'is_peserta',
          master: this.$mapForMaster(this.mStatusPeserta),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Pilih Angkatan',
          default: true,
          type: 'select',
          model: 'gelombang',
          master: this.$mapForMaster(this.mGelombang),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        },
      ];

      return temp;
    },
  },
  created() {
    this.getMasters('propinsi;kota');
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('pip', ['fetch', 'create', 'action']),

    allow(action, data) {
      let enable = false;
      switch (action.event) {
        case 'onAktivasi':
          enable = this.$allow(action.akses, data.policies) && +data.is_aktivasi !== 1;
          break;
        case 'onSetPeserta':
          enable = this.$allow(action.akses, data.policies) && +data.is_aktivasi === 1 && !this.isPeserta(data);
          break;
        case 'onDeletePeserta':
          enable = this.$allow(action.akses, data.policies) && +data.is_aktivasi === 1 && this.isPeserta(data);
          break;
        case 'onSetStatus':
          enable = this.$allow(action.akses, data.policies) && +data.is_aktivasi === 1;
          break;
        default:
          enable = this.$allow(action.akses, data.policies);
          break;
      }
      return enable;
    },

    msgConfirm(title, item) {
      return [
        '<div class="black--text">',
        `<p style="font-size: 16px" class="my-2">${title}</p>`,
        '<div class="card grey lighten-4 pa-3 mt-2">',
        `<div class="font-weight-medium indigo--text" style="font-size: 16px">${item.nama}</div>`,
        `<div class="body-2"><span class="font-weight-medium">SIMPKB ID:</span> ${this.$getDeepObj(
          item,
          'psp_profil.data.ptk_id'
        ) || '-'}</div>`,
        '</div>',
      ].join('');
    },

    isPeserta(data = {}) {
      return (this.$getDeepObj(data, 'psp_diklat_pesertas.data') || []).length > 0;
    },

    statusPeserta(data = {}) {
      const isPeserta = this.isPeserta(data);
      const profil = this.$getDeepObj(data, 'psp_profil.data') || {};
      const isAktif = profil && profil.is_aktif;
      const isAktivasi = data && +data.is_aktivasi === 1 ? 'aktivasi' : 'belum';
      const isDiskualifikasi = +isAktif === 0 ? 'diskualifikasi' : isAktivasi;
      const isPelaksana = isPeserta && +isAktif === 1 ? 'pelaksana' : isDiskualifikasi;
      const M_STATUS = {
        aktivasi: { color: 'success', label: 'Aktivasi', key: 'aktivasi' },
        belum: { color: 'error', label: 'Belum Aktivasi', key: 'belum' },
        pelaksana: { color: 'primary', label: 'Pelaksana', key: 'pelaksana' },
        diskualifikasi: { color: 'error', label: 'Diskualifikasi', key: 'diskualifikasi' },
      };

      return M_STATUS[isPelaksana];
    },

    onAddAkun() {
      this.$set(this.formulir, 'component', 'FormulirAkun');
      this.$set(this.formulir, 'action', 'add');
      this.$set(this.formulir, 'is_edit', true);
      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        if (this.$refs.formulir) this.$refs.formulir.reset();
        this.$set(this.formulir, 'title', 'Tambah Akun PIP');
        this.$set(this.formulir, 'init', {});
      });
    },

    onDelete(item) {
      const id = item.psp_registrasi_id;
      const type = 'delete';
      const msg = this.msgConfirm(`Apakan anda ingin menghapus Akun PIP berikut?`, item);

      this.$confirm(msg, 'Hapus Akun', { tipe: 'error' }).then(() => {
        this.action({ id, type }).then(() => {
          this.$success('Akun berhasil di hapus');
          this.fetchData();
        });
      });
    },

    onAktivasi(item) {
      const id = item.psp_registrasi_id;
      const type = 'resend-email';
      const msg = this.msgConfirm('Apakan anda ingin mengirim ulang email Aktivasi untuk Akun berikut?', item);

      this.$confirm(msg, 'Kirim Ulang Email Aktivasi').then(() => {
        this.action({ id, type }).then(() => {
          this.$success('Email Aktivasi telah dikirim');
        });
      });
    },

    onDetail(item) {
      this.$set(this.formulir, 'component', 'DetailAkun');
      this.$set(this.formulir, 'is_edit', false);
      this.$set(this.formulir, 'init', item);
      this.$set(this.formulir, 'title', 'Detail Akun PIP');
      this.$refs.modal.open();
    },

    onSetPeserta(item) {
      const id = `diklat/${item.psp_registrasi_id}`;
      const type = 'create';
      const msg = this.msgConfirm('Apakan anda ingin menjadikan akun berikut sebagi Peserta Diklat?', item);

      this.$confirm(msg, 'Set sebagai Peserta Diklat').then(() => {
        this.action({ id, type }).then(() => {
          this.$success('Berhasil menjadi Peserta Diklat');
          this.onReload();
        });
      });
    },

    async onSetStatus(item) {
      this.$set(this.formulir, 'title', 'Set Status');
      this.$set(this.formulir, 'action', 'undur');
      this.$set(this.formulir, 'component', 'FormStatus');
      this.$set(this.formulir, 'is_edit', true);
      this.$set(this.formulir, 'id', item.psp_registrasi_id);
      this.$refs.modal.open();
      this.$nextTick(() => {
        if (this.$refs.formulir) this.$refs.formulir.reset();
        this.$set(this.formulir, 'detail', item);
      });
    },

    onDeletePeserta(item) {
      const id = `diklat/${item.psp_registrasi_id}`;
      const type = 'delete';
      const msg = this.msgConfirm('Apakan anda ingin membatalkan Akun berikut menjadi Peserta Diklat?', item);

      this.$confirm(msg, 'Batalkan sebagai Peserta Diklat').then(() => {
        this.action({ id, type }).then(() => {
          this.$success('Berhasil membatalkan status Peserta Diklat');
          this.onReload();
        });
      });
    },

    onCloseModal() {
      if (!this.formulir.is_edit) {
        this.$refs.modal.dialog = false;
        return;
      }

      const msg = [
        '<h3>Apakah Anda yakin ingin keluar dari halaman formulir ini?</h3>',
        'data yang tidak disimpan akan hilang jika Anda keluar dari Halaman ini',
      ].join(' ');

      this.$confirm(msg, 'Peringatan', { tipe: 'error', lblConfirmColor: 'red', lblCancelColor: 'grey' }).then(() => {
        this.$refs.modal.dialog = false;
      });
    },

    onSave() {
      if (this.formulir.action === 'undur') this.onSaveStatus();
      else this.onSaveAkun();
    },

    onSaveAkun() {
      const params = this.$refs.formulir.getValue();

      this.create({ params })
        .then(() => {
          this.$refs.modal.dialog = false;
          this.$success('Akun berhasil ditambahkan');
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onSaveStatus() {
      const formulir = this.$refs.formulir.getValue();
      const id = this.formulir.id;
      const html = `<span class="subtitle-1">Anda Yakin ingin <strong>Set Status</strong> peserta berikut ?</span>`;

      // validasi
      const isAktif = formulir.is_aktif;
      if (isAktif === 0 && !formulir.berkas) {
        this.$error('Berkas pendukung tidak ditemukan');
        this.$refs.modal.loading = false;
        return;
      }
      if (isAktif === 0 && !formulir.alasan_diskualifikasi) {
        this.$error('Alasan diskualifikasi belum dipilih');
        this.$refs.modal.loading = false;
        return;
      }
      if (
        isAktif === 0 &&
        formulir.alasan_diskualifikasi === 'Alasan Lainnya' &&
        !formulir.alasan_diskualifikasi_lain
      ) {
        this.$error('Tuliskan Alasan lain diskualifikasi');
        this.$refs.modal.loading = false;
        return;
      }

      const params = new FormData();
      params.append('is_aktif', formulir.is_aktif);
      if (formulir.is_aktif === 0) {
        params.append('label', 'undur');
        params.append('file', formulir.berkas);
        params.append(
          'alasan_diskualifikasi',
          formulir.alasan_diskualifikasi === 'Alasan Lainnya'
            ? formulir.alasan_diskualifikasi_lain
            : formulir.alasan_diskualifikasi
        );
      }

      this.$confirm(html, 'Konfirmasi').then(() => {
        this.$refs.modal.loading = true;
        this.action({ id, type: 'save-mundur', params })
          .then(() => {
            this.$success('Berhasil disimpan');
            this.$refs.modal.dialog = false;
            this.onReload();
          })
          .catch(() => {
            this.$refs.modal.loading = false;
          });
      });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
